import { ContactCreateDTO, ContactDTO, ContactUpdateDTO } from "./dto";
import { ContactServiceImpl } from "./serviceImpl";


export interface ContactService {
    getContactById(id: string): Promise<ContactDTO>
    updateContact(id: string, data: ContactUpdateDTO): Promise<void>
    createContact(data: ContactCreateDTO): Promise<number>
    deleteContact(id: string): Promise<void>
}


export function NewContactService(): ContactService {
    return new ContactServiceImpl();
}